module.exports = __webpack_public_path__ + "static/media/logo.e6af86df.svg";